
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ components: {} })
export default class CircleProgress extends Vue {
  @Prop({ type: Number, default: 0 })
  progress!: number;

  @Prop({ type: Number, default: 20 })
  size!: number;

  @Prop({ type: Number, default: 2 })
  strokeWidth!: number;

  @Prop({ type: String, default: "#D5DFE7" })
  bgColor!: string;

  @Prop({ type: String, default: "#16a370" })
  strokeColor!: string;

  // 半径
  get radius() {
    return (this.size - this.strokeWidth) / 2;
  }

  // 绘制背景圆弧
  get circleBgDraw() {
    return `
      M${this.size / 2},1
      A${this.radius},${this.radius} 0 0,0 1,${this.size / 2}
      A${this.radius},${this.radius} 0 1,0 ${this.size / 2},1
   `;
  }

  // 绘制进度条圆弧
  get circleDraw() {
    return `
      M${this.size / 2},1
      A${this.radius},${this.radius} 0 1,1 1,${this.size / 2}
      A${this.radius},${this.radius} 0 0,1 ${this.size / 2},1
   `;
  }

  // 周长
  get perimeter() {
    return 2 * Math.PI * this.radius;
  }

  get progressLen() {
    if (this.progress === 100) return this.perimeter;

    const len = this.perimeter * (this.progress / 100) - 2;

    // 进度条保底
    return len < 1 ? 1 : len;
  }

  get bgLen() {
    if (!this.progress) return this.perimeter;

    return this.perimeter - this.progressLen - 2;
  }
}
